<template>
  <div v-if="access !== null">
    <setting-root-icon-popup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
      :jenis="jenis"
    />
    <!-- <SubKategoriZISPopup
      v-if="passParent !== null"
      :activate="activeSubmenu"
      @callback="callBackSubmenu"
      @withClose="loadData"
      :passData="passParent"
    /> -->
    <!-- TABLE ACTION ROW -->
    <header class="w-full">
      <div class="mb-base mt-4 vx-row justify-between items-top">
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
          <span class="text-black text-2xl"
            >Tabel Root Icon Kategori
            {{ jenis === 1 ? "ZIS" : jenis === 2 ? "Campaign" : "SOS" }} Mobile</span
          >
        </section>
        <!-- <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="openPopUp(null)" v-if="access.create === 1"
              >Tambah Kategori</vs-button
            >
          </section> -->
      </div>
      <div class="vx-row justify-between items-center">
        <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
          <div class="w-full gap-2 flex justify-start items-center">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{ `entries ${limit}` }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="(item, index) in limitDataTables"
                  :key="index"
                  @click="limit = item"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </section>
        <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
          <div class="w-full flex justify-end gap-2 flex-wrap items-center">
            <vs-input v-model="search" placeholder="Search..." />
          </div>
        </section>
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      ></div>
    </header>

    <main ref="loadRootIcon">
      <vs-table stripe :data="kategoris" v-model="selected" :max-items="limit">
        <template slot="thead">
          <vs-th
            >{{
              jenis === 1
                ? "Nama Kategori ZIS"
                : jenis === 2
                ? "Nama Kategori Campaign"
                : "Nama Kategori SOS"
            }}
          </vs-th>
          <vs-th>Root</vs-th>
          <vs-th>Icon</vs-th>
          <vs-th>Aksi</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td :data="data[indextr].root">
              {{ data[indextr].root ? data[indextr].root : "(Root Kosong)" }}
            </vs-td>
            <vs-td :data="data[indextr].icon">
              {{ data[indextr].icon ? data[indextr].icon : "(Icon Kosong)" }}
            </vs-td>
            <vs-td>
              <div class="flex justify-start gap-2">
                <vs-tooltip text="Edit">
                  <vs-button
                    v-if="access.update === 1"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="openPopUp(data[indextr])"
                  >
                  </vs-button>
                </vs-tooltip>
                <!-- <vs-tooltip text="Submenu">
                    <vs-button
                      color="warning"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-menu"
                      @click="openSubMenu(data[indextr])"
                    >
                    </vs-button>
                  </vs-tooltip> -->
                <!-- <vs-tooltip text="Delete">
                    <vs-button
                      v-if="access.delete === 1"
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="dialogDelete(data[indextr].id, data[indextr].name)"
                    >
                    </vs-button>
                  </vs-tooltip> -->
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </main>
    <footer>
      <div class="justify-end mt-2">
        <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
      </div>
    </footer>
  </div>
</template>

<script>
import SettingRootIconPopup from "@/views/iconRoot/component/SettingRootIconPopup.vue";
// import SubKategoriZISPopup from "@/views/zis/component/SubKategoriZISPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    SettingRootIconPopup,
    // SubKategoriZISPopup,
  },
  props: {
    jenis: { type: Number, default: 1 },
  },
  data() {
    return {
      emptyImage,
      url,
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      params: {},
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      activeSubmenu: false,
      passParent: null,
      passData: null,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      kategoris: [],
      search: "",
    };
  },
  computed: {
    totalPage() {
      let totalKat =
        this.jenis === 1
          ? this.$store.state.zis.totalKatRecords
          : this.jenis === 2
          ? this.$store.state.campaign.totalKatRecords
          : this.$store.state.sos.totalKatRecords;
      let pages = totalKat / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    search() {
      if (this.search !== "") {
        this.params = {
          search: this.search,
          filter: "name",
        };
      } else {
        this.params = {};
      }

      this.loadData(true);
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.loadData(true);
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.loadData(true);
    },
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    callBackSubmenu(val) {
      this.activeSubmenu = val;
      this.passParent = null;
    },
    loadData(val) {
      if (val) {
        if (this.jenis === 1) {
          this.getKatZIS();
        } else if (this.jenis === 2) {
          this.getKatCampaign();
        } else {
          this.getKatSOS();
        }
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    openSubMenu(item) {
      this.activeSubmenu = true;
      this.passParent = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadRootIcon,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("zis/cudKatZIS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Kategori ZIS ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.loadData(true);
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKatZIS() {
      this.$vs.loading({
        container: this.$refs.loadRootIcon,
        color: "primary",
      });
      this.$store
        .dispatch("zis/getKatZIS", { ...this.params, akses_admin: 1, ...this.pagination })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          this.kategoris = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKatCampaign() {
      this.$vs.loading({
        container: this.$refs.loadRootIcon,
        color: "primary",
      });
      this.$store
        .dispatch("campaign/getKatCampaign", { ...this.params, ...this.pagination })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          this.kategoris = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKatSOS() {
      this.$vs.loading({
        container: this.$refs.loadRootIcon,
        color: "primary",
      });
      this.$store
        .dispatch("sos/getKategoriSOS", { ...this.params, ...this.pagination })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          this.kategoris = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadRootIcon);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    if (this.jenis === 1) {
      this.getKatZIS();
    } else if (this.jenis === 2) {
      this.getKatCampaign();
    } else {
      this.getKatSOS();
    }
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/setting-root-icon"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/setting-root-icon"
        );
      }
    }
  },
};
</script>

<style scoped>
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
